export const GERMAN_TRANSLATIONS = {
  text: {
    web_title: 'Smartz Instrumententafel',
    authentication: 'Authentifizierung',
    username: 'Nutzername',
    password: 'Passwort',
    sign_in: 'Einloggen',
    username_required: 'Ein Benutzername ist erforderlich',
    password_required: 'Passwort wird benötigt',
    invalid_credential: 'Falscher Benutzername oder falsches Passwort',
    forgot_password: 'Passwort vergessen',
    logout: 'Ausloggen',
    languages: 'Sprachen',
    dashboard: 'Instrumententafel',
    products: 'Produkte',
    pods: 'Hülsen',
    reports: 'Berichte',
    this_website_uses_cookies: 'Diese Website verwendet Cookies',
    uses_cookie_desc:
      'Wir verwenden Cookies, um Inhalte und Anzeigen zu personalisieren, Social-Media-Funktionen bereitzustellen und unseren Traffic zu analysieren. Wir teilen auch Informationen über Ihre Nutzung unserer Website mit unseren Social-Media-, Werbe- und Analysepartnern, die diese mit anderen Informationen kombinieren können, die Sie ihnen zur Verfügung gestellt haben oder die sie aus Ihrer Nutzung ihrer Dienste gesammelt haben.',
    use_necessary_cookie_only: 'Verwenden Sie nur die erforderlichen Cookies',
    allow_selection: 'Auswahl zulassen',
    allow_all_cookies: 'Alle Cookies zulassen',
    hide_details: 'Details ausblenden',
    necessary: 'Notwendig',
    preferences: 'Einstellungen',
    statistics: 'Statistiken',
    marketing: 'Marketing',
    unclassified: 'Unklassifizierte',
    cookie_declaration: 'Cookie Erklärung',
    about_cookies: 'Informationen zu Cookies',
    necessary_desc:
      'Notwendige Cookies tragen dazu bei, eine Website nutzbar zu machen, indem sie grundlegende Funktionen wie Die Seitennavigation und den Zugriff auf sichere Bereiche der Website ermöglichen. Die Website funktioniert ohne diese Cookies nicht ordnungsgemäß.',
    preferences_desc:
      'Mit Präferenz-Cookies kann sich eine Website Informationen merken, die das Verhalten oder Aussehen der Website ändern, wie Ihre bevorzugte Sprache oder die Region, in der Sie sich befinden.',
    statistic_desc:
      'Statistic cookies help website owners to understand how visitors interact with websites by collecting and reporting information anonymously.',
    marketing_desc:
      'Statistische Cookies helfen Website-Besitzern zu verstehen, wie Besucher mit Websites interagieren, indem sie Informationen anonym sammeln und melden.',
    unclassified_desc:
      'Nicht klassifizierte Cookies sind Cookies, die wir zusammen mit den Anbietern einzelner Cookies klassifizieren.',
    about_cookies_desc:
      'Cookies sind kleine Textdateien, die von Websites verwendet werden können, um die Benutzererfahrung effizienter zu gestalten. Das Gesetz besagt, dass wir Cookies auf Ihrem Gerät speichern können, wenn sie für den Betrieb dieser Website unbedingt erforderlich sind. Für alle anderen Arten von Cookies benötigen wir Ihre Erlaubnis. Diese Website verwendet verschiedene Arten von Cookies. Einige Cookies werden von Drittanbieterdiensten platziert, die auf unseren Seiten erscheinen.',
    name: 'Namen',
    provider: 'Anbieter',
    purpose: 'Zweck',
    expiry: 'Ablauf',
    type: 'Typ',
    frequently_asked_questions: 'Häufig gestellte Fragen',
    information_for_use: 'Informationen zur Verwendung',
    data_privacy: 'Datenschutz',
    eula: 'EULA',
    about: 'Über',
    settings: 'Einstellungen',
    my_account: 'Mein Konto',
    version: 'version',
    support: 'unterstützung',
    close: 'Schließen',
    copyright: 'Copyright (C) 2020 Simavita Pty Ltd. Alle Rechte vorbehalten',
    manufacturers: 'hersteller',
    characterisation: 'charakterisierung',
    address: 'adresse',
    contact: 'kontakt',
    action: 'aktion',
    view: 'ansehen',
    edit: 'bearbeiten',
    add: 'hinzufügen',
    add_manufacturer: 'Hersteller Hinzufügen',
    edit_manufacturer: 'Bearbeiten Hersteller',
    created: 'Erstellt',
    details: 'Details',
    other: 'Andere',
    active: 'Aktiv',
    save: 'Speichern',
    product_description: 'Produktbeschreibung',
    general_product_description: 'allgemeine produktbeschreibung',
    product_characteristics: 'Produkteigenschaften',
    product_characterise_properties: 'produktcharakteristen',
    description: 'Beschreibung',
    working_capacity: 'Arbeitskapazität',
    add_product: 'Produkt hinzufügen',
    edit_product: 'Produkt bearbeiten',
    hardware: 'Hardware',
    position: 'Position',
    constant: 'Konstante',
    yellow_threshold: 'Gelbe Schwelle',
    red_threshold: 'Rote Schwelle',
    firmware_version: 'Firmware Version',
    hardware_version: 'Hardware Version',
    thresholds: 'Schwellenwerte',
    yellow: 'Gelb',
    red: 'Rot',
    product_characterisation: 'Produktcharakterisierung',
    run: 'Ausführen',
    characterisation_run: 'Charakterisierungslauf',
    analyse_runs: 'Analyse Runs',
    analyse_runs_desc: 'Analyse und Erstellung <br/> von Produktmerkmalen',
    product_characterisation_run: 'Produktcharakterisierungslauf',
    tester: 'Tester',
    pod: 'Pod',
    weight: 'Gewicht',
    incomplete_run: 'Unvollständiger Run',
    continue: 'Unvollständiger Run',
    start_new: 'Starten Sie neu',
    started: 'begann',
    finish: 'Beenden',
    entries: 'Einträge',
    time: 'Zeit',
    void: 'Leere',
    comment: 'Kommentar',
    add_entry: 'EINTRAG HINZUFÜGEN',
    pod_data: 'Pod Daten',
    sensor: 'sensor',
    select: 'Auswählen',
    export_data: 'Exportdaten',
    date: 'Datum',
    comments_for: 'Anmerkungen für',
    pad_characterization_detail_for: 'Pad Charakterisierung Detail für',
    desc: 'Desc',
    volume: 'Volumen',
    median: 'Median',
    agg: 'Agg',
    new_agg: 'Neue Agg',
    sensor_value: 'sensorwert',
    sensor_value_agg: 'sensorwert agg',
    select_run_to_analyse: 'Wählen Sie Run to Analyse',
    product_characterisation_analysis: 'Produktcharakterisierungsanalyse',
    chart_data: 'Diagrammdaten',
    calibration: 'Kalibrierung',
    capacitance_readings: 'Kapazitätslesungen',
    capacitance_sensor_readings: 'Kapazitätssensor-Messwerte',
    connection_status: 'Verbindungsstatus',
    pad_connections: 'Pad-Verbindungen',
    battery_levels: 'Batterie-Level',
    battery_level_and_status: 'Batteriestand und -status',
    accelerometer_readings: 'Beschleunigungsmesser-Messungen',
    ax_ay_az: 'Ax, Ay, Az und Position, fällt Status',
    chart_pod_capacitance_readings: 'Diagramm Pod Kapazität Lesungen',
    y_axis_max: 'Y-Achse max',
    auto_refresh: 'auto-refresh',
    apply: 'Anwenden',
    latest_time: 'Neueste Zeit',
    countdown_to_median: 'Countdown zu Median',
    recent_data_for: 'Aktuelle Daten für',
    chart_pod_connection_status: 'Diagramm-Pod-Verbindungsstatus',
    chart_pod_battery_level: 'Diagramm Pod Batteriestand',
    chart_pod_accelerometer: 'Diagramm Pod Beschleunigungsmesser',
    export_pod_data: 'Exportieren von Pod-Daten',
    raw_data: 'Rohdaten',
    export: 'Exportieren',
    from_date: 'ab Datum',
    to_date: 'bis heute',
    utc_offset: 'UTC offset',
    pod_calibration: 'Pod Kalibrierung',
    calibrattion_status: 'Calibrattion Status',
    capacitive: 'Kapazitive',
    accelerometer: 'Beschleunigungsmesser',
    calibration_data: 'Kalibrierdaten',
    capacitive_sensor: 'Kapazitiver Sensor',
    battery: 'Batterie',
    thermistor: 'Thermistor',
    spo2: 'SPO2',
    blood_oxygen_saturation: 'Blutsauerstoffsättigung',
    chart_pod_spo2_readings: 'Diagramm Pod SPO2-Lesungen',
    live: 'LIVE',
    chart_date: 'Diagrammdatum',
    please_select: 'Bitte wählen Sie',
    product: 'produkt',
    tester_required: 'Tester erforderlich',
    product_required: 'Produkt erforderlich',
    pod_required: 'Pod ist erforderlich',
    position_required: 'Position erforderlich',
    weight_required: 'Gewicht ist erforderlich',
    lying_left: 'Lying Left',
    lying_right: 'Lying Right',
    lying_back: 'Lying Back',
    lying_front: 'Lying Front',
    sit: 'Sitzen',
    stand: 'Stand',
    void_required: 'void ist erforderlich',
    comment_required: 'Kommentar erforderlich',
    please_select_a_product: 'Bitte wählen Sie ein Produkt aus',
    filter_by_group_or_users: 'Filtern nach Gruppe oder Benutzern',
    manage: 'Verwalten',
    users: 'Benutzer',
    roles: 'Rollen',
    user_accounts: 'BENUTZERKONTEN',
    role: 'Rolle',
    status: 'Status',
    disabled: 'Deaktiviert',
    add_user_account: 'HINZUFÜGEN EINES BENUTZERKONTOS',
    edit_user_account: 'BEARBEITEN DES BENUTZERKONTOS',
    fullname: 'Fullname',
    phone: 'Telefon',
    email: 'E-Mail',
    role_required: 'Rolle ist erforderlich',
    enter_correct_email: 'Bitte geben Sie die richtige E-Mail-Adresse ein',
    email_required: 'E-Mail ist erforderlich',
    add_role: 'ROLLE HINZUFÜGEN',
    edit_role: 'Rolle bearbeiten',
    role_name: 'Rolenname',
    role_permissions: 'Rollenberechtigungen',
    level_1_module: 'Modul Level 1',
    level_2_module: 'MOdul Level 2',
    permissions: 'Berechtigungen',
    cancel: 'Abbrechen',
    filter_by_role_name: 'Filtern nach Rollenname',
    chart_time: 'Diagrammzeit',
    vital_signs: 'Vitalfunktionen',
    heart_rate: 'Herzfrequenz',
    body_temperature: 'Körpertemperatur',
    pod_capacitance: 'Pod-Kapazität',
    pod_accel: 'unter accel',
    pod_status: 'Pod-Status',
    name_required: 'Name ist erforderlich',
    address_required: 'Adresse ist erforderlich',
    contact_required: 'Kontakt ist erforderlich',
    id_required: 'ID ist erforderlich',
    description_required: 'Beschreibung erforderlich',
    working_capacity_required: 'Arbeitsfähigkeit ist erforderlich',
    constant_a_required: 'Konstante A ist erforderlich',
    constant_b_required: 'Konstante B ist erforderlich',
    constant_c_required: 'Konstante C ist erforderlich',
    constant_d_required: 'Konstante D ist erforderlich',
    yellow_threshold_required: 'Gelber Schwellenwert erforderlich',
    red_threshold_required: 'Rote Schwelle ist erforderlich',
    firmware_version_required: 'Firmware-Version ist erforderlich',
    hardware_version_required: 'Hardware-Version ist erforderlich',
    group: 'Gruppe',
    reset_password: 'Passwort zurücksetzen',
    new_password: 'Neues Passwort',
    confirm_password: 'Passwort bestätigen',
    please_enter_password: 'Bitte geben Sie ein Passwort ein',
    please_enter_password_again: 'Bitte geben Sie das Passwort erneut ein',
    password_inconsistent: 'Die Passwörter stimmen nicht überein',
    saved_successfully: 'Erfolgreich gespeichert',
    s1_offset_required: 'S1_Offset ist erforderlich',
    s2_offset_required: 'S2_Offset ist erforderlich',
    s1_gain_required: 'S1_Gain ist erforderlich',
    s2_gain_required: 'S2_Gain ist erforderlich',
    bat_offset_required: 'Bat_Offset ist erforderlich',
    temp_offset_required: 'Temp_Offset ist erforderlich',
    acc_x_offset_required: 'Acc_XOffset ist erforderlich',
    acc_x_gain_required: 'Acc_XGain ist erforderlich',
    acc_y_offset_required: 'Acc_YOffset ist erforderlich',
    acc_y_gain_required: 'Acc_YGain ist erforderlich',
    acc_z_offset_required: 'Acc_ZOffset ist erforderlich',
    acc_z_gain_required: 'Acc_ZGain ist erforderlich',
    edit_roles: 'Rollen bearbeiten',
    available_roles: 'Verfügbare Rollen',
    assigned_roles: 'Zugewiesene Rollen',
    delete: 'Löschen',
    you_able_to_delete_data: 'Sie sind im Begriff zu delet',
    delete_role_confirm:
      'Beachten Sie, dass das Löschen von Rollen dauerhaft ist.',
    aggregate: 'Aggregat',
    magnitude: 'Größe',
    connection: 'Verbindung',
    fall: 'Fallen',
    tag_data: 'Tag-Daten',
    notes: 'Notizen',
    add_tag: 'Tag hinzufügen',
    'Run away line': 'Fluchtlinie',
    'Non responsive line': 'Nicht reaktionsschnelle Leitung',
    Divergence: 'Divergenz',
    'Disconnected line': 'Getrennte Leitung',
    'Saturated readings': 'Gesättigte Messwerte',
    Unexplained: 'Unerklärliche',
    please_enter: 'Bitte geben Sie',
    find_data: 'Daten Finden',
    find_tagged_data: 'Tagged Data suchen',
    find_data_with_tag: 'Suchen von Daten mit Tag',
    find: 'Finden',
    found: 'Gefunden',
    mac_address: 'MAC-Adresse',
    tag_timestamp: 'Tag Timestamp',
    tagged_by: 'Tagged Von',
    tag: 'Etikett',
    period: 'Zeitraum',
    clear_selected: 'Klar ausgewählt',
    code: 'Code',
    manufacturer_code_required: 'Herstellercode erforderlich',
    failed: 'Fehlgeschlagen',
    product_number: 'Produktnummer',
    manufacturer: 'Hersteller',
    product_number_required: 'Produktnummer erforderlich',
    manufacturer_required: 'Hersteller ist erforderlich',
    urine: 'Urin',
    max_capacity: 'Max. Kapazität',
    urine_details: 'Urin Details',
    urine_thresholds: 'Urinschwellen',
    max_capacity_required: 'Maximale Kapazität ist erforderlich',
    pod_id_required: 'Pod-ID erforderlich',
    choose_a_report: 'Wählen Sie einen Bericht',
    select_date_range: 'Datumsbereich auswählen',
    start_time: 'startzeit',
    end_time: 'endzeit',
    select_groups_to_collate:
      'Wählen Sie Gruppen aus, die zusammengebissen werden sollen.',
    all_groups: 'Alle Gruppen',
    group_include:
      'Gruppe, die in die Berichtsgenerierung eingeschlossen werden soll',
    export_report: 'Exportbericht',
    export_csv: 'Exportieren CSV',
    //translate permission list
    Dashboard: 'Instrumententafel',
    'Pod Accel': 'Unter Accel',
    'Pod Capacitance': 'Pod Capacitance',
    Products: 'Produkte',
    Manufacturers: 'Hersteller',
    'Product Description': 'Produktbeschreibung',
    'Product Characteristics': 'Produkteigenschaften',
    Run: 'Ausführen',
    'Analyse Runs': 'Analyse Runs',
    Pods: 'Hülsen',
    'Capacitance Readings Chart': 'Kapazität Lesungen Diagramm',
    'Connection Status Chart': 'Verbindungsstatusdiagramm',
    'Battery Levels Chart': 'Batteriestanddiagramm',
    'Accelerometer Readings Chart': 'Beschleunigungsmesser-Messdiagramm',
    'SPO2 Chart': 'SPO2-Diagramm',
    'Export Pod Data': 'Exportieren von Pod-Daten',
    Calibration: 'Kalibrierung',
    Manage: 'Verwalten',
    Users: 'Benutzer',
    Roles: 'Rollen',
    View: 'ansehen',
    Add: 'Hinzufügen',
    Edit: 'Bearbeiten',
    Delete: 'Löschen',
    Reports: 'Berichte',
    'Export CSV': 'Exportieren CSV',
    Export: 'Exportieren',
    'Find Data': 'Suchen von Daten',
    'Reset Password': 'Zurücksetzen des Kennworts',
    //end translate permission list
    ago: 'vor',
    value: 'Wert',
    min: 'Mindest',
    max: 'Max',
    are_you_sure: 'Bist du sicher',
    whether_continue:
      'Sie werden einen Eintrag hinzufügen, bitte bestätigen Sie, ob Sie'
  },
  country: 'Germany',
  language: 'deutsche',
  abb_name: 'de'
}
